module.exports = __webpack_public_path__ + "static/media/govtech_white.278e6bda.svg";